const headers = (headers) => {
    return Object.entries(headers).map(([key, value]) => `xhr.setRequestHeader("${key}", "${value}");`).join('\n')
}

export default options => {
    let XMLHttpRequest = `
const data;

const xhr = new XMLHttpRequest();
xhr.withCredentials = true;

xhr.addEventListener("readystatechange", function () {
  if (this.readyState === this.DONE) {
    console.log(this.responseText);
  }
});

xhr.open(method, url);
headers
xhr.send(data);

`
    XMLHttpRequest = XMLHttpRequest.replace(/url/i, `"${options.url}"`)
    XMLHttpRequest = XMLHttpRequest.replace(/const data/i, `const data = JSON.stringify(${JSON.stringify(options.data, null, 4)})`)
    XMLHttpRequest = XMLHttpRequest.replace(/method/i, `"${options.method.toUpperCase()}"`)
    XMLHttpRequest = XMLHttpRequest.replace(/headers/i, `${headers(options.headers)}`)
    return XMLHttpRequest
}
